import React from "react";

const IconCheckCSvg = ({ size = 26 }: { size?: number }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 26 26"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.495"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden
	>
		<path d="M22.75 13C22.75 18.3848 18.3848 22.75 13 22.75C7.61522 22.75 3.25 18.3848 3.25 13C3.25 7.61522 7.61522 3.25 13 3.25C18.3848 3.25 22.75 7.61522 22.75 13Z" />
		<path d="M8.66667 13.5417L11.7 16.575L17.3333 10.2917" />
	</svg>
);

export default IconCheckCSvg;
